( function( $, window ) {
	'use strict';

	$( function() {
		const interval = 250;
		const visibleHeight = 400;
		const activeClass = 'sticky-header-active';
		const $body = $( 'body' );
		const $staticHeaderSearchBody = $( '.js-search-body--header' );
		const $staticHeaderSearchTrigger = $( '.js-search-close--header' );
		const $stickyHeaderSearchBody = $( '.js-search-body--sticky' );
		const $stickyHeaderSearchTrigger = $( '.js-search-close--sticky' );
		let didScroll = false;
		let lastScroll = 0;

		$( window ).on( 'scroll', function() {
			didScroll = true;
		} );

		setInterval( function() {
			if ( didScroll ) {
				handleScroll();
				didScroll = false;
			}
		}, interval );

		const handleScroll = () => {
			const currentScrollTop = ( $( window ).scrollTop() || $( 'body' ).scrollTop() );

			if ( currentScrollTop > visibleHeight && currentScrollTop < lastScroll ) {
				if ( ! $body.hasClass( activeClass ) ) {
					$body.addClass( activeClass );

					if ( $staticHeaderSearchBody.hasClass( 'site-search--is-active' ) ) {
						$staticHeaderSearchTrigger.trigger( 'click' );
					}
				}
			} else {
				if ( $body.hasClass( activeClass ) ) {
					$body.removeClass( activeClass );

					if ( $stickyHeaderSearchBody.hasClass( 'site-search--is-active' ) ) {
						$stickyHeaderSearchTrigger.trigger( 'click' );
					}
				}
			}

			lastScroll = currentScrollTop;
		};

		$( window ).trigger( 'scroll' );
	} );
} )( jQuery, window );
